import React from 'react';

/**
 * WhySection - Shows why the task is important and reactivation alerts
 */
function WhySection({ task }) {
  const hasReactivation = task.is_reactivated && task.reactivation_reason;
  
  return (
    <>
      {/* Reactivation Alert */}
      {hasReactivation && (
        <div className="mb-5 bg-rose-500/10 border border-rose-500/20 rounded-xl p-4" data-testid="reactivation-alert">
          <div className="flex gap-3">
            <div className="flex-shrink-0 w-6 h-6 bg-rose-500/20 rounded-full flex items-center justify-center">
              <svg className="w-4 h-4 text-rose-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-semibold text-rose-400 uppercase tracking-wide mb-1">Oppgave reaktivert</p>
              <p className="text-sm text-rose-300 font-medium">{task.reactivation_reason}</p>
              {task.reactivated_at && (
                <p className="text-xs text-rose-400/70 mt-1">
                  Reaktivert: {new Date(task.reactivated_at).toLocaleDateString('nb-NO', { day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      
      {/* Purpose Section */}
      {task.purpose && (
        <div className="mb-5 bg-amber-500/10 border border-amber-500/20 rounded-xl p-4" data-testid="why-section">
          <div className="flex gap-3">
            <div className="flex-shrink-0 w-6 h-6 bg-amber-500/20 rounded-full flex items-center justify-center">
              <span className="text-amber-400 text-sm font-bold">!</span>
            </div>
            <div>
              <p className="text-xs font-semibold text-amber-400 uppercase tracking-wide mb-1">Hvorfor dette er viktig</p>
              <p className="text-sm text-amber-200">{task.purpose}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default WhySection;
